import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

import { map } from "rxjs/operators";
import { GroupForm } from "app/interfaces/group-form.interface";

const gpsTacticalMapUrlApi = environment.gpsTacticalMapUrlApi;
const gpsTacticalMapDevicesUrlApi = environment.gpsTacticalMapDevicesUrlApi;
const gpsAllIncidentsUrlApi = environment.gpsAllIncidentsUrlApi;
const gpsFake = environment.gpsFake;

@Injectable()
export class MapService {
  public user: GroupForm;
  constructor(private http: HttpClient) {}

  getTacticalMap(id: number) {
    return this.http
      .request("GET", `${gpsTacticalMapUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getTacticalMapDevices() {
    return this.http
      .request("GET", `${gpsTacticalMapDevicesUrlApi}`, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  getAllIncidentsMap() {
    return this.http
      .request("GET", `${gpsAllIncidentsUrlApi}`, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  fakeGpsFootage(size, id_device, id_video, id_footage, type) {
    let body = { size, id_device, id_video, id_footage, type };

    body.size = size;
    body.id_device = id_device;
    body.id_video = id_video;
    body.id_footage = id_footage;
    body.type = type;

    return this.http
      .request("POST", `${gpsFake}`, { body })
      .pipe(map((resp: any) => resp));
  }
  /* 
  getGroupById(id: number) {
    return this.http
      .request("GET", `${groupsUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  updateGroupById(id: number, groupModel: GroupForm) {
    console.log(id);
    console.log(groupModel);
    const body = groupModel;
    return this.http
      .request("PUT", `${groupsUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  createGroup(groupModel: GroupForm) {
    console.log(groupModel);
    const body = groupModel;
    return this.http
      .request("POST", `${groupsUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  assignRoles(idGroup: number, arrayRolesSelected) {
    const body = { id_roles: arrayRolesSelected };
    return this.http
      .request("PUT", `${groupsAssignRolesUrlApi}/` + idGroup, { body })
      .pipe(map((resp: any) => resp));
  }

  deleteGroupById(id: number) {
    return this.http
      .request("DELETE", `${groupsUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  } */
}
